module.exports = __webpack_public_path__ + "img/ly.a6f2fdc2.svg";